module.exports = __webpack_public_path__ + "media/Instruction_64.282a3e75.mp3";